module.exports = __webpack_public_path__ + "media/images/proof_links/reddit-f2aba2d26c16df15cf1813376c9f4330.svg";